import { createSlice } from '@reduxjs/toolkit';
import { fetchStockItems, fetchStockItemById } from '../actions/stockItemActions';

const initialState = {
  items: { count: 0, items: [] }, 
  item: null,
  loading: false,
  error: null,
  status: 'idle',
  filter: {
    minPrice: null,
    maxPrice: null,
    sizes: [],
  },
};

const stockItemSlice = createSlice({
  name: 'stockItem',
  status: 'idle',
  initialState,
  reducers: {
    filterStockItems: (state, action) => {
      const { minPrice, maxPrice, sizes } = action.payload;
      state.items = state.items.filter(item => {
        const isInPriceRange = (minPrice === null || item.defaultPrice >= minPrice) && (maxPrice === null || item.defaultPrice <= maxPrice);
        const hasSize = sizes.length === 0 || item.sizes.some(size => sizes.includes(size));
        return isInPriceRange && hasSize;
      });
    },
    searchStockItems: (state, action) => {
      const query = action.payload.toLowerCase();
      const originalItems = state.originalItems || state.items;
      const filteredItems = originalItems.filter(item => {
        return (
          item.name.toLowerCase().includes(query) ||
          item.id.toString().toLowerCase().includes(query)
        );
      });
      state.items = filteredItems;
      state.originalItems = originalItems;
      if (query.length === 0) {
        state.items = originalItems;
        state.originalItems = null;
      }
    },
    setLoad: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStockItems.pending, (state) => {
        state.status = 'loading';
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStockItems.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchStockItems.rejected, (state, action) => {
        state.status = 'failed';
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchStockItemById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStockItemById.fulfilled, (state, action) => {
        state.loading = false;
        state.item = action.payload;
      })
      .addCase(fetchStockItemById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const {
  filterStockItems,
  searchStockItems,
  setLoad,
  setError,
} = stockItemSlice.actions;

export default stockItemSlice.reducer;
